var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLangCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_dropdown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2828427,10.2828427 L16.3171573,14.3171573 C16.473367,14.473367 16.473367,14.726633 16.3171573,14.8828427 C16.2421427,14.9578573 16.1404012,15 16.0343146,15 L7.96568542,15 C7.74477153,15 7.56568542,14.8209139 7.56568542,14.6 C7.56568542,14.4939134 7.60782816,14.3921718 7.68284271,14.3171573 L11.7171573,10.2828427 C11.873367,10.126633 12.126633,10.126633 12.2828427,10.2828427 Z",
    id: "Triangle",
    fill: "#000000",
    transform: "translate(12.000000, 12.500000) scale(1, -1) translate(-12.000000, -12.500000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLangCollapse);
export default __webpack_public_path__ + "static/media/ic_lang_collapse.f54a600c.svg";
export { ForwardRef as ReactComponent };